import React from "react";
import PropTypes from "prop-types";

const Overlay = ({ show, onAgree, children }) => {
  if (!show) {
    return children;
  }

  return (
    <div className="tw-relative">
      {children}
      <div className="tw-absolute tw-inset-0 tw-flex tw-items-center tw-justify-center tw-z-50 tw-backdrop-filter-blur">
        <div className="tw-absolute tw-inset-0 tw-bg-black tw-opacity-50" />
        <div className="tw-bg-white tw-p-10 tw-rounded tw-shadow-lg tw-z-10 tw-flex tw-flex-col tw-items-center tw-justify-center tw-space-y-4">
          <p className="tw-font-bold tw-leading-5">
            Warning: VarSome does not include all possible data sources. For the
            most accurate classification upgrade to Premium
          </p>
          <p>
            For more information{" "}
            <a href="https://varsome.com/datasources/">click here</a>
          </p>
          <button
            type="button"
            className="tw-px-4 tw-py-0.5 tw-font-semibold tw-text-xl tw-bg-primary tw-text-white tw-cursor-pointer"
            onClick={onAgree}
          >
            I understand
          </button>
        </div>
      </div>
    </div>
  );
};

Overlay.propTypes = {
  show: PropTypes.bool.isRequired,
  onAgree: PropTypes.func.isRequired,
  children: PropTypes.node.isRequired,
};

export default Overlay;
